<h1 class="title" translate>HOMEPAGE.REPORT.TITLE</h1>
<app-page-wrapper>
  <div class="ic1-my-12">
    <ng-ui-kit-toast
      *ngIf="showSuccess && mode === 'manage_report'"
      status="success"
      [text]="
        'REPORT_PAGE.PK_BOX.SUCCESS_REPORT'
          | translate: { state: (successText | translate) }
      "
      (click)="showSuccess = false">
    </ng-ui-kit-toast>
    <ng-ui-kit-toast
      *ngIf="showSuccess && mode === 'change_email'"
      status="success"
      [text]="'REPORT_PAGE.PK_BOX.SUCCESS_EMAIL' | translate"
      (click)="showSuccess = false">
    </ng-ui-kit-toast>
  </div>
  <!-- Attiva/Disattiva Report -->
  <div class="ic1-my-12">
    <ng-ui-kit-card
      [header]="true"
      [data]="true"
      className="type-2"
      [text]="'REPORT_PAGE.PK_BOX.ACTIVATION_CARD.DESC' | translate"
      type="summative"
      [attr.translate-key]="'REPORT_PAGE.PK_BOX.ACTIVATION_CARD.DESC'"
      [button]="cardReportButton">
      <ng-container header>
        <div class="ic1-header-left">
          <label class="ic1-text-label-1" translate
            >REPORT_PAGE.PK_BOX.ACTIVATION_CARD.TITLE</label
          >
          <ng-ui-kit-badge
            [color]="activeReport ? 'success' : 'warning'"
            size="sm"
            [label]="
              'SUSPEND_PAGE.AUTOMATIC_CARD.ICON_TEXT'
                | translate: { state: (iconText | translate) }
            "></ng-ui-kit-badge>
        </div>
      </ng-container>
      <div class="view-data-mobile" data>
        <span
          [ngClass]="
            activeReport
              ? 'ic1-badge-success-alternative'
              : 'ic1-badge-warning-alternative'
          ">
          <span
            [innerHTML]="
              'SUSPEND_PAGE.AUTOMATIC_CARD.ICON_TEXT'
                | translate: { state: (iconText | translate) }
            "></span>
        </span>
        <label
          class="ic1-text-body-1"
          [innerHTML]="
            'REPORT_PAGE.PK_BOX.ACTIVATION_CARD.DESC' | translate
          "></label>
      </div>
    </ng-ui-kit-card>
  </div>

  <!-- Cambio Email -->
  <div class="ic1-my-12">
    <ng-ui-kit-card
      type="summative"
      [title]="'REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.TITLE' | translate"
      [text]="'REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.DESC' | translate"
      [attr.translate-key]="
        'REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.TITLE,REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.DESC'
      "
      [button]="cardEmailButton"
      [labels]="cardEmailLabel">
    </ng-ui-kit-card>
  </div>
</app-page-wrapper>

<app-common-modal
  modalId="rep-modal"
  [title]="'REPORT_PAGE.PK_BOX.ACTIVATION_CARD.TITLE' | translate"
  [(visible)]="repModalVisible"
  [config]="{ size: 'md', persistent: true, hideButtons: true }"
  (onClose)="onToggleRepModal(false)">
  <ng-container *ngIf="renderRepModalContent">
    <div
      class="ic1-col-12 desc ic1-my-12"
      [innerHTML]="'REPORT_PAGE.PK_BOX.ACTIVATION_CARD.DESC' | translate"
      translate-key="REPORT_PAGE.PK_BOX.ACTIVATION_CARD.DESC"></div>
    <div class="ic1-col-12 buttons-container">
      <ng-ui-kit-button
        color="secondary"
        [label]="'COMMON.BUTTON.CANCEL' | translate"
        type="button"
        size="sm"
        (onClick)="closeModal()">
      </ng-ui-kit-button>
      <app-submit-button
        [color]="'tertiary'"
        type="submit"
        [label]="
          'SUSPEND_PAGE.AUTOMATIC_CARD.BUTTON_TEXT'
            | translate: { state: (buttonText | translate) }
        "
        translate-key="SUSPEND_PAGE.AUTOMATIC_CARD.BUTTON_TEXT"
        [disabled]="loading"
        (onClick)="manageReport()">
      </app-submit-button>
    </div>
  </ng-container>
</app-common-modal>

<app-common-modal
  modalId="email-modal"
  [title]="'REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.TITLE' | translate"
  [(visible)]="emailModalVisible"
  [config]="{ size: 'lg', persistent: true, hideButtons: true }"
  (onClose)="onToggleEmailModal(false)">
  <ng-container *ngIf="renderEmailModalContent">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- FIRST STEP START-->
      <div class="ic1-my-16">
        <ng-ui-kit-accordion
          [disabled]="showEmailModalStep2"
          [title]="'REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.TITLE' | translate"
          [open]="showEmailModal"
          [icon]="!showEmailModal ? 'check' : ''"
          [step]="showEmailModal ? 1 : 0">
          <ng-container content>
            <div class="ic1-row">
              <div class="ic1-col-12 desc ic1-mb-12" translate>
                REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.DESC
              </div>

              <!-- INPUT FIELDS -->
              <div class="ic1-col-12 ic1-col-lg-6">
                <ng-ui-kit-input
                  formControlName="emailField"
                  name="emailField"
                  autocomplete="emailField"
                  autocomplete="emailField"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                  [placeholder]="
                    'REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.EMAIL_PLACEHOLDER'
                      | translate
                  "
                  type="text"
                  icName="emailField"
                  icId="emailField"
                  [label]="
                    'REPORT_PAGE.PK_BOX.CHANGE_EMAIL_CARD.TITLE' | translate
                  "
                  [status]="
                    emailStep1Attempted && emailField.invalid
                      ? 'error'
                      : 'informative'
                  ">
                </ng-ui-kit-input>
                <app-field-validator
                  *ngIf="emailStep1Attempted"
                  [field]="emailField"
                  [formErrors]="formErrors"></app-field-validator>
              </div>
              <div class="ic1-col-12 buttons-container ic1-mt-16">
                <ng-ui-kit-button
                  color="secondary"
                  [label]="'COMMON.BUTTON.CANCEL' | translate"
                  type="button"
                  size="sm"
                  (onClick)="clearForm(); closeModal()">
                </ng-ui-kit-button>
                <app-submit-button
                  [label]="'COMMON.BUTTON.SAVE' | translate"
                  translate-key="COMMON.BUTTON.SAVE"
                  [loading]="loading"
                  [disabled]="loading"
                  (onClick)="goToEmailSecondStep()">
                </app-submit-button>
              </div>
            </div>
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
      <!-- SECOND STEP START-->
      <div class="ic1-my-16">
        <ng-ui-kit-accordion
          [disabled]="showEmailModal"
          [title]="'COMMON.ACCORDION_OTP.TITLE' | translate"
          [open]="showEmailModalStep2"
          [icon]="showSuccess ? 'check' : ''"
          [step]="!showSuccess ? 2 : 0">
          <ng-container content
            ><div class="desc ic1-mb-12" translate>COMMON.ACCORDION_OTP.DESC</div>
            <div class="ic1-col-12">
              <div class="ic1-form-group">
                <app-otp-input
                  formControlName="otp"
                  [error]="emailStep2Attempted && otp.invalid"
                  [errorDisclaimerText]="getEmailOtpErrorDisclaimerText()"
                  [startTimer]="showEmailModalStep2"></app-otp-input>
              </div>
            </div>
            <div class="buttons-container ic1-mt-16">
              <button
                type="button"
                (click)="goToEmailStepOne()"
                class="ic1-btn ic1-btn-sm ic1-btn-secondary cancel-button">
                <div translate>COMMON.BUTTON.CANCEL</div>
              </button>
              <app-submit-button
                type="submit"
                [loading]="loading"
                [disabled]="loading"
                [label]="'COMMON.BUTTON.CONFIRM' | translate"
                translate-key="COMMON.BUTTON.CONFIRM"
                (onClick)="onSubmit()"></app-submit-button>
            </div>
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
    </form>
  </ng-container>
</app-common-modal>
